import { Button } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import Card from 'components/Card'
import ConfirmReindexProviderModal from 'components/providers/searchEngine/ConfirmReindexProviderModal'
import { SEARCH_ENGINE_INDEXES } from 'components/providers/searchEngine/searchEngineApi'
import SearchEngineDocumentsModal from 'components/providers/searchEngine/SearchEngineDocumentsModal'

interface Props {
    providerId: number
}

const SearchEngineCard = ({ providerId }: Props) => (
    <Card
        header="Search engine"
        icon="manage_search"
        infoHover="What the search engine currently has indexed for this provider, to check whether it is in sync with the database.">
        <div className="flex gap-2 pt-2">
            {SEARCH_ENGINE_INDEXES.map((index) => (
                <Button
                    key={index.label}
                    appearance="secondary"
                    onClick={() =>
                        NiceModal.show(SearchEngineDocumentsModal, { providerId, index })
                    }>
                    {index.label}
                </Button>
            ))}
            <Button
                appearance="primary"
                onClick={() => NiceModal.show(ConfirmReindexProviderModal, { providerId })}>
                Reindex provider
            </Button>
        </div>
    </Card>
)

export default SearchEngineCard
